export const FEATURE_NAMESPACE = 'feature.process-engineer-dashboard'
